import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { SettingsProvider } from "@/context/SettingsContext";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";

import Home from "@/pages/Home";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import { Blog, BlogPost } from "@/pages/Blog";
import { Login, Register } from "@/pages/Auth";
import Account, { Favorites } from "@/pages/Account";
import { PaymentSuccess, PaymentFail } from "@/pages/Payment";

import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminCustomers from "@/pages/admin/AdminCustomers";
import AdminReviews from "@/pages/admin/AdminReviews";
import AdminBanners from "@/pages/admin/AdminBanners";
import AdminBlog from "@/pages/admin/AdminBlog";
import AdminCoupons from "@/pages/admin/AdminCoupons";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminOtogars from "@/pages/admin/AdminOtogars";

function PublicLayout({ children }) {
  return (
    <>
      <Header />
      <main className="min-h-[60vh]">{children}</main>
      <Footer />
      <FloatingWhatsApp />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <SettingsProvider>
          <Toaster position="top-right" richColors />
          <Routes>
            {/* Admin routes (no header/footer) */}
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="urunler" element={<AdminProducts />} />
              <Route path="kategoriler" element={<AdminCategories />} />
              <Route path="siparisler" element={<AdminOrders />} />
              <Route path="musteriler" element={<AdminCustomers />} />
              <Route path="yorumlar" element={<AdminReviews />} />
              <Route path="bannerlar" element={<AdminBanners />} />
              <Route path="blog" element={<AdminBlog />} />
              <Route path="kuponlar" element={<AdminCoupons />} />
              <Route path="otogarlar" element={<AdminOtogars />} />
              <Route path="ayarlar" element={<AdminSettings />} />
            </Route>

            {/* Public routes */}
            <Route path="/*" element={
              <PublicLayout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/urunler" element={<Products />} />
                  <Route path="/urunler/:categorySlug" element={<Products />} />
                  <Route path="/urun/:slug" element={<ProductDetail />} />
                  <Route path="/sepet" element={<Cart />} />
                  <Route path="/odeme" element={<Checkout />} />
                  <Route path="/odeme/basarili" element={<PaymentSuccess />} />
                  <Route path="/odeme/basarisiz" element={<PaymentFail />} />
                  <Route path="/hakkimizda" element={<About />} />
                  <Route path="/iletisim" element={<Contact />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/blog/:slug" element={<BlogPost />} />
                  <Route path="/giris" element={<Login />} />
                  <Route path="/kayit" element={<Register />} />
                  <Route path="/hesabim" element={<Account />} />
                  <Route path="/hesabim/favoriler" element={<Favorites />} />
                </Routes>
              </PublicLayout>
            } />
          </Routes>
          </SettingsProvider>
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
